module.exports = __webpack_public_path__ + "static/media/wanyin-app@2x.7d0d83f5.png";